import React from 'react';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const InGoodStandingIcon = ({ toolTipText = 'In Good Standing' }) => (
  <Icon tooltip={ toolTipText } iconObj={faCircleCheck} />
);

export default InGoodStandingIcon;